<template>
  <div id="main-editor">

    <div id="grid-table-contents">
      <div class="grid-table-scroll">
        <table class="table table-sm table-striped sticky_table">
          <thead>
            <tr>
              <th class="col-check">チェック</th>
              <th class="col-number">No.</th>
              <th class="col-order-id">注文番号</th>
              <th class="col-header-item">商品名</th>
              <th class="col-name">名前</th>
              <th class="col-postal-code">郵便番号</th>
              <th>住所</th>
              <th class="col-ship-method">配送方法</th>
              <th>メモ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in getShippingData"
              v-bind:key="index"
              v-bind:id = "row.index"
              @click.prevent="onClickRow(row)"
              >
              <td @click.stop="onClickMark(row)">
                <CheckedMark
                  :checked="row.checkedStep3"
                  :failureMark="false"
                />
              </td>
              <td>{{row.index}}</td>
              <td>{{row.orderId}}</td>
              <td>
                <div v-for="(item, itemNum) in row.items" v-bind:key="itemNum" class="col-item">
                  {{item.productName}}
                </div>
              </td>
              <td :class="warnNameTag(row.recipientName)">{{row.recipientName}}</td>
              <td>{{row.shipPostalCode}}</td>
              <td class="col-address" :class="warnAddressTag(row.shipState + ' ' + row.shipCity + ' ' + row.shipAddress1 + ' ' + row.shipAddress2 + ' ' + row.shipAddress3)">
                {{row.address()}}
              </td>
              <td>{{row. shipMethodLabel()}}</td>
              <td>
                <div v-for="(memo, memoNum) in row.autoMemo()" v-bind:key="memoNum" class="col-item">
                  {{memo}}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <EditMode
      :row="thisRecord"
      @closeEditor="closeEditor"
      v-if="thisRecord !== null"
    />

  </div>
</template>

<script>
import { defineComponent, computed, ref } from 'vue'
import createStore from '@/store/index.js'
import CheckedMark from '@/components/CheckedMark.vue'
import EditMode from '@/components/shipping/EditMode.vue'
// import { createPdfFromHtml } from '@/js/pdf.js'
import { warnName, warnAddress } from '@/js/shipping/warnStep3.js'

export default defineComponent({
  components: {
    CheckedMark,
    EditMode
  },
  setup () {
    const onShow = ref(false)
    const thisRecord = ref(null)

    const onClickMark = (row) => {
      // 選択したデータのチェック
      store.commit('updateStep3Check', { row: row })
    }

    const onClickRow = (row) => {
      console.log('clicked')
      console.log(row)
      thisRecord.value = row
      // onShow.value = true
    }

    const store = createStore

    const getShippingData = computed(() => {
      return store.getters.getShippingData
    })

    // 名前の警告表示
    const warnNameTag = (name) => {
      const rtn = { warning: false }
      rtn.warning = warnName(name)
      return rtn
    }

    // 名前の警告表示
    const warnAddressTag = (address) => {
      const rtn = { warning: false }
      rtn.warning = warnAddress(address)
      return rtn
    }

    // 編集モード解除
    const closeEditor = () => {
      // onShow.value = false
      thisRecord.value = null
    }

    return {
      getShippingData,
      onShow,
      thisRecord,
      onClickRow,
      onClickMark,
      warnNameTag,
      warnAddressTag,
      closeEditor
    }
  }
})
</script>

<style lang="scss" scoped>
#main-editor {
  #grid-table-contents {
    position: absolute;
    height: 100%;
    width: 100%;
    font-size: small;

    .grid-table-scroll {
      position: relative;
      overflow-y: scroll;
      height: 100%;
      width: 100%;

      .sticky_table {
        width: 100%;
        white-space: nowrap;
        vertical-align: middle;

        thead th {
          /* 縦スクロール時に固定する */
          position: sticky;
          top: 0;
          /* tbody内のセルより手前に表示する */
          z-index: 1;
          background: #604878;
          color: white;
          text-align: center;
        }
        tr {
          height: 1rem;
          padding-top: 0;
          padding-bottom: 0;
          margin-top: 0;
          margin-bottom: 0;
        }
        tr:hover td{
          background-color: #F5E974;
          color: black;
          cursor: pointer;
        }
        td {
          background: white;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          max-width: 0;
          border-right: black 0.5px solid;
        }
        .warning {
          background-color: red;
          color: white;
        }
        .col-check {
          width: 2rem;
        }
        .col-number {
          width: 3rem;
        }
        .col-order-id {
          width: 14rem;
        }
        .col-postal-code {
          width: 8rem;
        }
        .col-item {
          text-align: left;
          white-space: nowrap;
        }
        td.col-address {
          text-align: left;
          white-space: nowrap;
        }
        td.col-send {
          width: 5rem;
        }
        td.col-shelf-number {
          white-space: nowrap;
        }
        .col-name {
          width: 6rem;
        }
        .col-ship-method {
          width: 5rem;;
        }
      }
    }
  }
}
</style>
